<div class="ota-list-container">
        <ag-grid-angular
        style="width: 100%; height: 580px;"
        class="ag-theme-alpine"
        [gridOptions]="gridOptions"
        [columnDefs]="columnDefs"
        [rowData]="rowData"
      ></ag-grid-angular>
  </div>

    
      <!-- <div style="display: flex; justify-content: center; align-items: center;">
        <button mat-stroked-button color="primary" (click)="goToPage(1)">First</button>
        <button mat-stroked-button color="primary" (click)="goToPage(currentPage - 1)">Previous</button>
        <button mat-stroked-button color="primary">1</button>
        <button mat-stroked-button color="primary" (click)="goToPage(currentPage + 1)">Next</button>
        <button mat-stroked-button color="primary" (click)="goToPage(totalPages)">Last</button>
      </div> -->

  